import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useMemo } from 'react';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';
import { IInstallationSiteModel } from '../../../../entities-generated/models/project/installation-site-model';
import { CartInstallationListing } from '../cart-install-listing';
import { where } from '../../../../framework/utils/collection';

interface ICartInstallationSiteListingProps {
  site: IInstallationSiteModel;
  allowExclusion: boolean;
  excludeExcluded?: boolean;
  suppressNotification?: boolean;
  onExclude: (installation: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onInclude: (installation: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onDoorSelected: (installation: IDoorInstallationModel, site: IInstallationSiteModel) => void;
  onHandleSelected: (installation: IDoorInstallationModel, site: IInstallationSiteModel) => void;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    borderBottom: `1px solid ${theme.palette.neutralTertiaryAlt}`,
  };

  const heading: IStyle = {
    fontSize: theme.fonts.xLarge.fontSize,
    fontWeight: 700,
    lineHeight: theme.fonts.xLarge.lineHeight,
    margin: 0,
    marginTop: '1.25rem',
    marginBottom: '0.75rem',
    padding: 0,
  };

  return mergeStyleSets({
    root,
    heading,
  });
}

export const CartInstallationSiteListing: React.FunctionComponent<ICartInstallationSiteListingProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { site, excludeExcluded } = props;
  const doorInstallations = useMemo(() => {
    return excludeExcluded === true
      ? where(site.doorInstallations, door => door.isExcluded === false)
      : site.doorInstallations;
  }, [site, excludeExcluded]);

  return (
    <div>
      <h2 className={cs.heading}>
        {site.name}
      </h2>
      {doorInstallations.map(install =>
      <CartInstallationListing
        key={install.id}
        installation={install}
        allowExclusion={props.allowExclusion}
        onExclude={i => props.onExclude(i, site)}
        onInclude={i => props.onInclude(i, site)}
        onDoorSelected={i => props.onDoorSelected(i, site)}
        onHandleSelected={i => props.onHandleSelected(i, site)}
        supressNotification={props.suppressNotification === true}
      />)}
    </div>
  );
};
